/* eslint-disable  */

import { APIClient } from "./_api";
const endpoint = "/OrderConfirmationForm";

export function getAll() {
  return APIClient.get(`${endpoint}`);
}

export function create(values) {
  return APIClient.post(`${endpoint}`, values);
}
export function edit(values) {
  return APIClient.put(`${endpoint}/${values.id}`, values.data);
}

export function deleteItem(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}
